export const WHY_CHOOSE_AH_CHECK_COMPENSATION_EVENT_UA = [
  "clicked",
  "SectionWhyChooseAirhelp",
  "CheckYourCompensation",
] as const;

export const WHY_CHOOSE_AH_CHECK_COMPENSATION_EVENT = {
  event: "check_compensation",
  label: "check_your_compensation",
  placement: "section_why_choose_airhelp",
} as const;

export const negativeItems = [
  {
    headingTranslationKey: "why_airhelp_stressful",
    textTranslationKey: "why_airhelp_stressful_description",
  },
  {
    headingTranslationKey: "why_airhelp_lots_of_paperwork",
    textTranslationKey: "why_airhelp_lots_of_paperwork_description",
  },
  {
    headingTranslationKey: "why_airhelp_time_consuming",
    textTranslationKey: "why_airhelp_time_consuming_description",
  },
  {
    headingTranslationKey: "why_airhelp_risky",
    textTranslationKey: "why_airhelp_risky_description",
  },
  {
    headingTranslationKey: "why_airhelp_unresponsive_airlines",
    textTranslationKey: "why_airhelp_unresponsive_airlines_description",
  },
];

export const positiveItems = [
  {
    headingTranslationKey: "why_airhelp_easy_hassle_free",
    textTranslationKey: "why_airhelp_easy_hassle_free_description",
  },
  {
    headingTranslationKey: "why_airhelp_we_take_care_of_it",
    textTranslationKey: "why_airhelp_we_take_care_of_it_description",
  },
  {
    headingTranslationKey: "why_airhelp_save_time",
    textTranslationKey: "why_airhelp_save_time_description",
  },
  {
    headingTranslationKey: "no_win_no_free",
    textTranslationKey: "no_win_no_free_description",
  },
  {
    headingTranslationKey: "why_airhelp_regular_updates",
    textTranslationKey: "why_airhelp_regular_updates_description",
  },
];
